export const flattenColumnsRecursive = all => all.flatMap(arr => (arr.columns ? flattenColumnsRecursive(arr.columns) : arr));
export default flattenColumnsRecursive;
